import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { filledCollectorFields } from '../../util/collectorProfile';

import css from './CollectorCard.module.css';

/**
 * Nextmine: den lille samler-bio.
 *
 * Vises kun med de felter samleren faktisk har udfyldt - et halvt udfyldt kort
 * skal ligne et bevidst valg, ikke en mangel. Er intet udfyldt, vises kortet
 * slet ikke (bortset fra på ens egen side, hvor man får en invitation).
 *
 * @param {Object} props
 * @param {Object} props.publicData brugerens offentlige profildata
 * @param {string?} props.className ekstra klasse på roden
 */
const CollectorCard = props => {
  const { publicData, className } = props;
  const fields = filledCollectorFields(publicData);

  if (fields.length === 0) {
    return null;
  }

  return (
    <div className={classNames(css.root, className)}>
      <dl className={css.list}>
        {fields.map(({ key, value }) => (
          <div className={css.row} key={key}>
            <dt className={css.label}>
              <FormattedMessage id={`CollectorCard.${key}Label`} />
            </dt>
            <dd className={css.value}>{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default CollectorCard;
